import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ItemSummaryItemSummaryService} from '../shared/asset/item-summary-item-summary.service';
import {ItemSummaryEquipmentSummaryService} from '../shared/asset/item-summary-equipment-summary.service';
import {Asset, AssetInfo, AssetSaleInfo} from '../shared/domain/item';
import {Opportunity} from '../shared/domain/opportunity';
import {AuctionEvent} from '../shared/domain/auction-event';
import {ItemSummaryItemService} from '../shared/asset/item-summary-item.service';
import {ItemSummaryEquipmentService} from '../shared/asset/item-summary-equipment.service';
import {ItemViewType} from '../shared/item-view-type.enum';
import {AssetPackageDto} from '../shared/domain/asset-package';
import {ItemSummaryPageService} from "../shared/asset/item-summary-page.service";

@Component({
  selector: 'lib-item-summary-equipment-summary',
  templateUrl: './equipment-summary.component.html',
  styleUrls: ['./equipment-summary.component.scss'],
  providers: [
    {provide: ItemSummaryItemSummaryService, useClass: ItemSummaryEquipmentSummaryService},
    {provide: ItemSummaryItemService, useClass: ItemSummaryEquipmentService}
  ]
})
export class EquipmentSummaryComponent implements OnInit {

  @Input() itemId: number;
  @Input() fromView: ItemViewType;
  @Input() canAccess: boolean;
  @Output() editModeChanged = new EventEmitter<boolean>();
  asset: Asset;
  assetInfo: AssetInfo;
  assetSaleInfo: AssetSaleInfo;
  assetPackage: AssetPackageDto;
  opportunity: Opportunity;
  auctionEvent: AuctionEvent;
  isAuctionEventActive: boolean;
  isEventEndedMoreThan30DaysAgo: boolean;
  isEventEndedMoreThan120DaysAgo: boolean;

  constructor(public itemSummaryService: ItemSummaryItemSummaryService,
              public itemService: ItemSummaryItemService,
              private itemSummaryPageService: ItemSummaryPageService) {
  }

  ngOnInit() {
  }

  onAssetLoaded(asset: Asset) {
    this.asset = asset;
    this.itemSummaryPageService.loadAssetInformation(this.asset);
  }

  onAssetInfoLoaded(assetInfo: AssetInfo) {
    this.assetInfo = assetInfo;
    this.itemSummaryPageService.loadAssetInfoInformation(this.assetInfo);
  }

  onAssetSaleInfoLoaded(assetSaleInfo: AssetSaleInfo) {
    this.assetSaleInfo = assetSaleInfo;
  }

  onAssetPackageLoaded(assetPackage: AssetPackageDto): void {
    this.assetPackage = assetPackage;
  }

  onOpportunityLoaded(opportunity: Opportunity) {
    this.opportunity = opportunity;
  }

  onAuctionEventLoaded(auctionEvent: AuctionEvent) {
    this.auctionEvent = auctionEvent;
    this.isAuctionEventActive = this.auctionEvent.activeAuction;
    this.isEventEndedMoreThan30DaysAgo = auctionEvent.eventEndedMoreThan30DaysAgo;
    this.isEventEndedMoreThan120DaysAgo = auctionEvent.eventEndedMoreThan120DaysAgo;
    this.itemSummaryPageService.loadAuctionEventInformation(this.auctionEvent);
  }

  public isSiteEventView(): boolean {
    return this.fromView === ItemViewType.SiteEvent;
  }

  public isAssetPortalView(): boolean {
    return this.fromView === ItemViewType.AssetPortal;
  }

  onEditModeChanged(isOnEditMode: boolean) {
    this.editModeChanged.emit(isOnEditMode);
  }

}
